/*
 * Package: WebVideo.PerformerPerson
 * Version: $Id$
 * Copyright (c) 2011-2015 Sergey Leonov
 */

function PerformerPerson() {}

PerformerPerson.FIELD_CUSTOM_PREFIX = "performer_custom_";
PerformerPerson.FIELD_REFERRAL_PERFORMER_ID = "pf";

PerformerPerson.getFBConnectionUrl = function (login_redirect_url) {
  var _url = Config.performer + "/login/facebook";
  _url += "?performer_withdraw_type=2"; //PayeePerson.WITHDRAW_TYPE_PAYPAL = 2;
  _url += "&performer_events_timezone=" + TimeUtils.getTzNameByLocation(Config.location, Config.defaultTimezone);
  if (login_redirect_url != null) {
    _url += "&login_redirect_url=" + encodeURI(login_redirect_url);
  }
  return _url;
};

PerformerPerson.initFBLogin = function (login_redirect_url) {
  FB.login(function(response) {
    if (response.status == 'connected') {
      document.location.href = PerformerPerson.getFBConnectionUrl(login_redirect_url);
    }
  }, {perms:'email,user_birthday,user_about_me,user_photos'});
};

PerformerPerson.submitJoinForm = function (form) {
  //screen name
  if (form.elements["performer_screen_name"].type == "hidden") {
    form.elements["performer_screen_name"].value = form.elements["performer_name"].value;
  }
  //time zone
  form.elements["performer_events_timezone"].value = TimeUtils.getTzNameByLocation(Config.location, Config.defaultTimezone);
  //payout method
  form.elements["performer_withdraw_type"].value = "2"; //PayeePerson.WITHDRAW_TYPE_PAYPAL = 2;
  return true;
};

PerformerPerson.detectReferralId = function () {
  var regex = new RegExp("[\\#]"+PerformerPerson.FIELD_REFERRAL_PERFORMER_ID+"=(.+)");
  var qs = regex.exec(window.location.href);
  if (qs != null) {
    jQuery.ajax({
      "dataType": "json",
      "cache" : false,
      "type": "GET",
      "url": Config.exec + "/_ajaj-webvideo-gateway.jsp?"+PerformerPerson.FIELD_REFERRAL_PERFORMER_ID+"="+qs[1],
      "data": {
        "command": "get-referral-performer-id"
      }
    });
  }
};